var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 6.93552C34.9634 8.40822 37 11.4663 37 15C37 18.5337 34.9634 21.5918 32 23.0645M36 33.5328C39.0229 34.9007 41.745 37.13 44 40M4 40C7.89298 35.0452 13.1784 32 19 32C24.8216 32 30.107 35.0452 34 40M28 15C28 19.9706 23.9706 24 19 24C14.0294 24 10 19.9706 10 15C10 10.0294 14.0294 6 19 6C23.9706 6 28 10.0294 28 15Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers02);
export default __webpack_public_path__ + "static/media/users-02.79aef8cef32d349f0cc18ff74f7fe279.svg";
export { ForwardRef as ReactComponent };